const ru = {
  nav: {
    studio: "Студия",
    servizi: "Услуги",
    portfolio: "Портфолио",
    team: "Команда",
    journal: "Журнал",
    studioTagline: "Цифровая студия",
    contatti: "Контакты",
    parliamone: "Обсудим",
  },
  common: {
    iniziamoProgetto: "Начать проект",
    scriviStudio: "Написать в студию",
    vediServizi: "Все услуги",
    conosciStudio: "О студии",
    scopriDiPiu: "Узнать больше",
  },
  footer: {
    overline: "Студия · 2026",
    headline1: "Создаём",
    headlineEditorial: "цифровой опыт",
    headline2: "на заказ.",
    navHeading: "Навигация",
    writeHeading: "Напишите нам",
    tagline:
      "3D-моделирование · Прототипирование · Цифровые среды · Творческая поддержка.",
    rights: "Все права защищены",
    madeWith: "Сделано с тихой одержимостью",
  },
  home: {
    hero: {
      overline: "Цифровая студия · Основана Риккардо и Сашей",
      title1: "Придаём",
      titleEditorial: "форму",
      title2: "вашему",
      title3: "воображению.",
      paragraph:
        "Mysterious Stew — студия из двух человек, объединяющая 3D-моделирование, прототипирование и цифровые среды в единой творческой мастерской, с сетью внешних сотрудников для любых задач.",
      cta1: "Начать проект",
      cta2: "Что мы делаем",
    },
    marquee: [
      "3D-моделирование",
      "Рендеринг",
      "Прототипирование",
      "Оптимизация STL",
      "Цифровые среды",
      "Творческая режиссура",
      "Print-ready",
      "Motion",
    ],
    services: {
      overline: "Услуги · Четыре дисциплины",
      title1: "Одна студия,",
      titleEditorial: "четыре материи",
      title2: "для композиции.",
      paragraph:
        "К каждому проекту относимся как к единственному в своём роде. Подбираем нужные компетенции — свои или наших партнёров — чтобы получить максимально точный результат.",
      items: [
        {
          title: "3D-моделирование",
          desc: "Hard-surface и органический sculpting. Ассеты для рендера, кино, игр или печати.",
        },
        {
          title: "Прототипирование и 3D-печать",
          desc: "От файла до осязаемого объекта. Прототипы, мастер-модели, ограниченные серии.",
        },
        {
          title: "Цифровые среды",
          desc: "Виртуальные сцены, иммерсивные пространства, фотореалистичные сцены для сторителлинга и продукта.",
        },
        {
          title: "Цифровая поддержка",
          desc: "Постоянная творческая режиссура: консалтинг, workflow, производство контента и координация.",
        },
      ],
    },
    studio: {
      overline: "Студия · Два основателя",
      titleRiccardo: "Риккардо",
      titleAmp: "&",
      titleSasha: "Саша.",
      titleLine2: "Один core team,",
      titleLine3: "расширенная сеть.",
      paragraph:
        "Нас двое, но мы не работаем в одиночку. Собираем нужную команду для каждого проекта, подключая иллюстраторов, аниматоров, скульпторов и разработчиков, с которыми сотрудничаем годами.",
      role: "Со-основатель",
    },
    finalCta: {
      overline: "Следующий шаг",
      title1: "Есть идея?",
      titleEditorial: "Приготовим её вместе.",
      button: "Написать в студию",
    },
  },
  services: {
    header: {
      overline: "Услуги",
      title1: "Четыре дисциплины,",
      titleEditorial: "один общий язык",
      titleEnd: ".",
      paragraph:
        "Мы не предлагаем стандартных пакетов. Каждый проект проходит с вами — от первого эскиза до финальной сдачи — с подключением нужных компетенций в нужный момент.",
    },
    items: [
      {
        tag: "3D",
        title: "3D-моделирование",
        desc: "Hard-surface и органический sculpting, low-poly и high-poly моделирование. Ассеты для фотореалистичного рендера, кино, игр или 3D-печати.",
        deliverables: [
          "Модели STL / OBJ / FBX",
          "Retopology & UV",
          "Итеративный concept-to-model",
          "Мастер-модели",
        ],
      },
      {
        tag: "PRINT",
        title: "Прототипирование и 3D-печать",
        desc: "От файла до осязаемого объекта. Подготовка поддержек, оптимизация для смолы/FDM, функциональные прототипы и ограниченные серии.",
        deliverables: [
          "Файлы print-ready",
          "Поддержки и ориентация",
          "Функциональные прототипы",
          "Ограниченные серии",
        ],
      },
      {
        tag: "ENV",
        title: "Цифровые среды",
        desc: "Виртуальные сцены, иммерсивные пространства, фотореалистичные или стилизованные сцены для сторителлинга, презентации продукта, интерактивного опыта.",
        deliverables: [
          "Фотореалистичные сцены",
          "Виртуальные сцены",
          "Real-time превью",
          "Анимированные сиквенсы",
        ],
      },
      {
        tag: "STUDIO",
        title: "Цифровая поддержка",
        desc: "Постоянная творческая режиссура: консалтинг, workflow, производство контента и координация с внешними партнёрами.",
        deliverables: [
          "Творческая режиссура",
          "Производство контента",
          "Workflow-дизайн",
          "Команда on-demand",
        ],
      },
    ],
    cta: {
      overline: "Гибридный бриф?",
      title1: "Лучшие проекты",
      title2: "рождаются на",
      titleEditorial: "границе",
      titleEnd: ".",
      button: "Расскажите о проекте",
    },
  },
  team: {
    intro: {
      overline: "Студия",
      title1: "Две руки",
      titleEditorial: "много голосов",
      titleEnd: ".",
      paragraph:
        "Основной состав — два человека. Вокруг нас — устойчивая сеть внешних сотрудников: иллюстраторов, аниматоров, скульпторов, разработчиков, — что позволяет собирать нужную команду под каждый проект, не теряя цельности.",
    },
    founders: [
      {
        name: "Риккардо",
        role: "Со-основатель · Цифровая скульптура и творческая режиссура",
        badge: "Со-основатель 01",
        bio: "Работает с фигурами, силуэтами и позами. Ведёт визуальную эстетику студии и озвучивает более тактильную, материальную сторону нашей работы.",
        focus: ["Sculpting", "Character design", "Art direction"],
      },
      {
        name: "Саша",
        role: "Со-основатель · Hard-surface и технический workflow",
        badge: "Со-основатель 02",
        bio: "Отвечает за техническую сторону: hard-surface, retopology, printability и архитектуру сквозных процессов.",
        focus: ["Hard-surface", "Printability", "Tech pipeline"],
      },
    ],
    crew: {
      overline: "Расширенная сеть",
      title1: "Команда, которая",
      titleEditorial: "собирается",
      title2: "вокруг проекта.",
      paragraph:
        "Мы не агентство с фиксированными отделами. Подключаем нужных специалистов под каждый случай — а мы двое остаёмся константой, обеспечивающей направление, качество и непрерывность.",
      items: [
        { role: "Иллюстраторы", count: "02", desc: "Концепт и визуальный дизайн." },
        { role: "Аниматоры", count: "02", desc: "Motion и анимированные секвенции." },
        { role: "Скульпторы", count: "03", desc: "Финиш и специальные детали." },
        { role: "Разработчики", count: "02", desc: "Backend и веб-интеграции." },
      ],
    },
    manifesto: {
      overline: "Наш подход",
      quote:
        "\u00ABМы предпочитаем сделать несколько проектов с одержимой внимательностью, чем много — впопыхах.\u00BB",
      button: "Работать с нами",
    },
  },
  portfolio: {
    header: {
      overline: "Портфолио · Подборка",
      title1: "Проекты,",
      titleEditorial: "не продукты",
      titleEnd: ".",
      paragraph:
        "Подборка недавних коллабораций студии — от моделирования и цифровых сред до прототипов для 3D-печати.",
    },
    projects: [
      {
        id: "obsidian-vault",
        title: "Obsidian Vault",
        tag: "Цифровая среда",
        desc: "Иммерсивная среда для запуска люксового продукта: моделирование, освещение и постпродакшн.",
      },
      {
        id: "forma-01",
        title: "Forma 01",
        tag: "3D-моделирование",
        desc: "Серия абстрактных цифровых скульптур для ограниченной коллекции.",
      },
      {
        id: "corpo-solido",
        title: "Corpo Solido",
        tag: "Прототипирование",
        desc: "Быстрое прототипирование механического компонента. Итерация от файла до готовой детали.",
      },
      {
        id: "vitrea",
        title: "Vitrea",
        tag: "Цифровая среда",
        desc: "Виртуальная сцена для редакционной кампании бренда аксессуаров.",
      },
      {
        id: "atelier-site",
        title: "Atelier — редакционный сайт",
        tag: "Веб-сайт",
        desc: "Индивидуальный сайт для студии современного искусства. Дизайн, разработка и CMS.",
      },
      {
        id: "collettivo",
        title: "Collettivo",
        tag: "Творческая поддержка",
        desc: "Постоянный консалтинг для арт-коллектива: workflow и производство контента.",
      },
    ],
    cta: {
      overline: "Похожий проект?",
      title1: "У каждого проекта",
      title2: "свой",
      titleEditorial: "правильный вопрос",
      titleEnd: ".",
      button: "Начнём разговор",
    },
  },
  journal: {
    header: {
      overline: "Журнал · Заметки студии",
      title1: "Заметки,",
      titleEditorial: "не туториалы",
      titleEnd: ".",
      paragraph:
        "Мысли, закулисье и размышления о ремесле. Обновляем журнал, когда есть, что сказать — а не для календаря.",
    },
    tags: [
      "3D",
      "Моделирование",
      "Print",
      "Заметки",
      "Workflow",
      "Режиссура",
      "Среды",
      "Коллаборации",
    ],
    readTimeLabel: "Чтение",
    readTimeUnit: "мин",
    backLabel: "Назад в журнал",
    moreLabel: "Другие заметки",
    entries: [
      {
        slug: "superficie-e-luce",
        date: "12 · 02 · 2026",
        tag: "Заметка",
        title: "Как мы думаем о люксовом 3D-моделировании",
        excerpt:
          "Внутренняя заметка, ставшая публичной: почему наша одержимость поверхностью связана не столько с блеском, сколько со светом.",
        readTime: "6",
        intro:
          "Эта заметка родилась из внутреннего разговора в студии — перед рендером, который нас не убеждал. Модель была технически безупречна, и всё же выглядела… дёшево. С этого началось размышление о том, что на самом деле делает цифровой объект «люксовым».",
        sections: [
          {
            h: "Поверхность — это не полировка",
            p: "Когда говорят о моделировании высокого уровня, инстинкт подсказывает добавлять: больше полигонов, больше бликов, больше деталей. Мы научились делать наоборот. Люксовая поверхность — это контролируемая поверхность: непрерывная кривизна, чистые переходы, никаких случайных дефектов. Деталь существует только там, где нужна, и у каждой фаски продуманный радиус.",
          },
          {
            h: "Форму рассказывает свет",
            p: "Модель оценивают, перемещая свет по её поверхности. Если блики текут без разрывов — форма решена; если ломаются, никакой материал её не спасёт. Поэтому мы тратим больше времени на кривизну, чем на текстуры: ощущение качества рождается там, задолго до финального рендера.",
          },
          {
            h: "Что это меняет для клиентов",
            p: "Это значит, что в наших сметах есть невидимая строка: время на то, что не видно с первого взгляда, но всегда ощущается. Это разница между цифровым объектом, который «работает», и тем, который кажется настоящим, ценным, желанным. Именно поэтому наши клиенты возвращаются.",
          },
        ],
      },
      {
        slug: "anatomia-prototipo",
        date: "24 · 01 · 2026",
        tag: "Workflow",
        title: "От эскиза к печати — анатомия прототипа",
        excerpt:
          "Разбираем недавний проект, чтобы показать, как мы соединяем моделирование, retopology и 3D-печать, когда важен каждый миллиметр.",
        readTime: "9",
        intro:
          "Механическая деталь, жёсткие допуски и клиент с реальным дедлайном. Проходим по этапам недавнего проекта, чтобы показать, как мы работаем, когда файл должен стать физическим объектом.",
        sections: [
          {
            h: "Первый эскиз — уже инженерия",
            p: "Каждый прототип начинается на бумаге, но с чёткими ограничениями с первого штриха: реальные размеры, точки нагрузки, ориентация печати. Рисовать, не думая о производстве, — значит перерисовывать потом. В нашем процессе форма и осуществимость рождаются вместе.",
          },
          {
            h: "Retopology: где выигрываются миллиметры",
            p: "Переход от скульптурной модели к производственной сетке — самая тихая и самая критичная фаза. Гарантированные минимальные толщины стенок, замкнутая геометрия, проверенные поверхности. Саша проверяет каждую критичную зону сечениями: когда одна деталь должна войти в другую, права на ошибку нет.",
          },
          {
            h: "Печать — это проверка, а не финиш",
            p: "Первая напечатанная деталь никогда не бывает финальной. Она нужна, чтобы измерить, собрать, понять, где реальность расходится с файлом. В этом проекте понадобилось три итерации: третья встала на место с чётким щелчком, без люфта. Этот звук — точный щелчок — и есть настоящий результат.",
          },
        ],
      },
      {
        slug: "manifesto-pacchetti",
        date: "08 · 01 · 2026",
        tag: "Журнал",
        title: "Маленький манифест против готовых пакетов",
        excerpt:
          "Каждый проект — своя задача. Поэтому у нас нет стандартных прайсов и это меняет способ работы с нами.",
        readTime: "4",
        intro:
          "Нас часто спрашивают: «Сколько стоит 3D-модель? А цифровая среда?». Честный ответ: зависит. Этот маленький манифест объясняет, почему у нас нет прайс-листа и почему мы считаем это преимуществом для тех, кто с нами работает.",
        sections: [
          {
            h: "Каждый проект — другой вопрос",
            p: "Готовый пакет предполагает, что все задачи похожи. Наш опыт говорит об обратном: один и тот же запрос — «модель для печати» — может занять три дня или три недели в зависимости от назначения, материала и уровня отделки. Оценивать до понимания — значит оценивать плохо.",
          },
          {
            h: "Смета как первый акт проекта",
            p: "Для нас смета — это не число, а первый черновик проекта. В ней есть фазы, запланированные итерации, что включено и что мы советуем отложить. Клиент, читающий нашу смету, уже знает, как мы будем работать вместе — ещё до подписи.",
          },
          {
            h: "Меньше проектов, но лучше",
            p: "Отказ от логики пакетов заставляет выбирать: мы берём только те проекты, которым можем уделить настоящее внимание. Коммерчески это против течения, но именно поэтому каждая работа, выходящая из студии, несёт одинаковую тщательность — от первого до последнего пикселя.",
          },
        ],
      },
      {
        slug: "rete-estesa",
        date: "22 · 12 · 2025",
        tag: "Коллаборации",
        title: "Расширенная сеть: кто стоит за каждым проектом",
        excerpt:
          "Иллюстраторы, аниматоры, скульпторы. Люди вокруг core team и как их подбирают под каждый заказ.",
        readTime: "5",
        intro:
          "На сайте мы пишем: «core team из двух человек, расширенная сеть коллабораторов». Но что это значит на практике? Кто на самом деле работает над вашими проектами и как мы выбираем, с кем сотрудничать?",
        sections: [
          {
            h: "Два человека как точка опоры",
            p: "Риккардо и Саша ведут каждый проект от начала до конца: креативное руководство, отношения с клиентом, контроль качества. Ничто не покидает студию, не пройдя через наши руки. Это гарантирует целостность — один стандарт, один голос в каждой сдаче.",
          },
          {
            h: "Как мы выбираем коллабораторов",
            p: "Расширенная сеть — это не список фрилансеров по случаю: это профессионалы, с которыми мы работаем годами — иллюстраторы, аниматоры, скульпторы, разработчики. Каждый выбран по реальным проектам, а не по собеседованиям. Если имя есть в нашей сети — значит, человек уже доказал, что держит наш стандарт.",
          },
          {
            h: "Преимущество для клиента",
            p: "Эта модель соединяет лучшее из двух миров: внимание и прямую ответственность маленькой студии с производственной мощностью большой команды. Клиент всегда говорит с нами двумя, но за каждым проектом собирается именно та команда, которую требует заказ.",
          },
        ],
      },
    ],
    cta: {
      overline: "Оставайтесь на связи",
      title1: "Немного заметок,",
      titleEditorial: "когда это важно",
      titleEnd: ".",
      button: "Написать по коллаборации",
    },
  },
  contact: {
    header: {
      overline: "Контакты",
      title1: "Давайте",
      title2: "начнём",
      titleEditorial: "разговор",
      titleEnd: ".",
      paragraph:
        "Есть проект, идея или вопрос? Пишите спокойно. Риккардо и Саша отвечают лично, обычно в течение нескольких дней.",
    },
    form: {
      nameLabel: "Имя",
      namePlaceholder: "Как вас зовут?",
      emailLabel: "Email",
      emailPlaceholder: "you@email.com",
      subjectLabel: "О чём говорим?",
      messageLabel: "Сообщение",
      messagePlaceholder: "Расскажите о проекте, идее, сроках…",
      hint: "Отвечаем лично, обычно в течение 3 рабочих дней.",
      submit: "Отправить",
      submitting: "Отправка…",
      validationError: "Заполните имя, email и сообщение.",
      sendError: "Ошибка отправки. Попробуйте чуть позже.",
      successToast: "Сообщение отправлено — скоро ответим.",
    },
    services: [
      "3D-моделирование",
      "Прототипирование и 3D-печать",
      "Цифровые среды",
      "Цифровая поддержка",
      "Другое",
    ],
    wizard: {
      stepWord: "Шаг",
      ofWord: "из",
      step1Title: "Над чем работаем?",
      step2Title: "Какой бюджет вы рассматриваете?",
      step2Hint: "Оценка нужна лишь для ориентира — без обязательств.",
      budgetOptions: ["До 500 €", "500 – 1 500 €", "1 500 – 5 000 €", "Более 5 000 €", "Определим вместе"],
      step3Title: "Когда нужен результат?",
      timelineOptions: ["Срочно (до 2 недель)", "В течение месяца", "1 – 3 месяца", "Гибко"],
      step4Title: "Расскажите о проекте",
      step5Title: "Ваши контакты",
      summaryTitle: "Итог запроса",
      next: "Далее",
      back: "Назад",
      selectHint: "Выберите вариант, чтобы продолжить",
    },
    thanks: {
      overline: "Получено",
      title1: "Спасибо —",
      titleEditorial: "скоро вернёмся",
      titleEnd: ".",
      paragraph:
        "Ваше сообщение дошло до студии. Ответим лично в течение нескольких рабочих дней.",
      again: "Написать ещё одно сообщение",
    },
    info: {
      emailTitle: "Прямой email",
      emailNote:
        "Для коллабораций, запросов на печать или смет. Отвечаем лично.",
      whereTitle: "Где мы",
      whereValue: "Италия",
      whereNote: "Удалённая студия · работаем с клиентами в Европе и не только.",
      timeTitle: "Время ответа",
      timeValue: "3 рабочих дня",
      timeNote: "Отвечаем на каждое сообщение по очереди.",
    },
  },
  seo: {
    home: {
      title: "Mysterious Stew — Цифровая студия · 3D, печать и цифровые среды",
      description:
        "Цифровая студия Риккардо и Саши: 3D-моделирование, прототипирование и 3D-печать, цифровые среды и творческая поддержка.",
    },
    servizi: {
      title: "Услуги — 3D-моделирование, 3D-печать и цифровые среды · Mysterious Stew",
      description:
        "Четыре дисциплины, один язык: 3D-моделирование, прототипирование и 3D-печать, цифровые среды и постоянная цифровая поддержка.",
    },
    team: {
      title: "Студия — Риккардо и Саша · Mysterious Stew",
      description:
        "Два основателя и расширенная сеть коллабораторов: иллюстраторы, аниматоры, скульпторы и разработчики вокруг каждого проекта.",
    },
    journal: {
      title: "Журнал — Заметки студии · Mysterious Stew",
      description:
        "Заметки, закулисье и размышления о ремесле: 3D-моделирование, процессы печати, креативное руководство.",
    },
    contatti: {
      title: "Контакты — Начнём проект · Mysterious Stew",
      description:
        "Расскажите о своём проекте: 3D-моделирование, прототипирование, цифровые среды или творческая поддержка. Личный ответ в течение 3 дней.",
    },
  },
  mmf: {
    views: "Просмотры",
    likes: "Лайки",
    followers: "Подписчики",
    models: "Опубликованные модели",
    visit: "Смотреть всё на MyMiniFactory",
    collectionsLabel: "Наши фракции",
    viewerLabel: "3D-превью",
    viewerTitle: "Потрогайте",
    viewerTitleEditorial: "своими руками.",
    viewerHint: "Перетащите, чтобы повернуть",
    viewerLoading: "Загрузка модели…",
    featuredLabel: "Избранные модели",
  },
  language: {
    label: "Язык",
  },
};

export default ru;
